import {initializePaddle} from '@paddle/paddle-js';

export const retainUIClient = async (customerId: string) =>
  initializePaddle({
    token: import.meta.env.VITE_PADDLE_TOKEN,
    pwCustomer: {
      id: customerId,
    },
  });

type FlowType = 'cancel' | 'pause';

export const retainRunFlow = async (
  flowtype: FlowType,
  customerId: string,
  subscriptionId: string
) => {
  const retain = (await retainUIClient(customerId))?.Retain;
  if (!retain) {
    throw new Error('Retain client not initialized');
  }
  const isDevelopment = import.meta.env.VITE_PADDLE_TOKEN.startsWith('test');
  console.log(`Running ${flowtype} flow, isDevelopment: ${isDevelopment}`);

  switch (flowtype) {
    case 'cancel':
      try {
        await (isDevelopment
          ? retain.demo({ feature: 'cancellationFlow' })
          : retain.initCancellationFlow({ subscriptionId: subscriptionId}));
      } catch (error) {
        console.error('Error starting cancellation flow:', error);
        throw error;
      }
      break;
    default:
      throw new Error('Invalid flow type');
  }
};
